import React, { useCallback, useState } from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import { useObserver } from '../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { Icon } from '../../concepts/resources/Icon';
import { DropButton } from '../../ui/DropButton';
import { useResolve } from '../Container';
import { usePermissionCheck } from '../common/PermissionElements';
import { WorkspaceModel } from '../dashboard/Models';
import { Copy, CopyDrop } from '../dashboard/elements/LayoutElements';
import { Prompt } from './../../ui';
import { AsidePanel } from './AsidePanel';
import { workspaceSetDescription } from './WorkspaceCommands';

export const WorkspaceAboutPanel = () => {

    const dispatch = useResolve(CommandDispatcher);
    const workspace = useObserver(useResolve(WorkspaceModel));
    const canEdit = usePermissionCheck('da:write', 'wo:write') && workspace.joined && workspace.type === 'team';

    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(workspace.description);

    const onAction = useCallback((confirm: boolean) => {
        if (confirm) dispatch(workspaceSetDescription, [workspace.id, value]);
        else setValue(workspace.description);
        setEditing(false);
    }, [value]);

    return <AsidePanel>
        <AsidePanel.Heading>
            <span>About</span>
            {!editing &&
                <DropButton rounding="full" onClick={() => setEditing(true)}>
                    {canEdit && <Icon src="deqo://icons/hero/pencil-alt" />}
                </DropButton>
            }
            {!!editing &&
                <DropButton rounding="full" className="ignore-prompt" onClick={() => onAction(true)}>
                    <Icon src="deqo://icons/hero/check@[0.75,0.75,0]" />
                </DropButton>
            }
        </AsidePanel.Heading>
        <AsidePanel.Content>
            {!editing && <>
                <Copy>{workspace.type === 'user' ? 'This is your personal workspace.' : value}</Copy>
            </>}
            {editing && <>
                <CopyDrop>
                    <Prompt clickOffIsPositive onAction={onAction}>
                        <TextareaAutosize
                            autoFocus
                            value={value}
                            onFocus={(e: any) => e.target.select()}
                            onChange={(e: any) => setValue(e.target.value)} />
                    </Prompt>
                </CopyDrop>
            </>}
        </AsidePanel.Content>
    </AsidePanel>;
};
